(function () {
  var menu = document.querySelector('[data-cebe-cafe-menu]');
  if (!menu) return;
  var navigation = menu.querySelector('.cebe-cafe-menu__categories');
  if (!navigation) return;
  var list = navigation.querySelector('ul');
  var links = Array.from(navigation.querySelectorAll('a[href^="#menu-"]'));
  var headings = links.map(function (link) {
    return document.getElementById(link.hash.slice(1));
  }).filter(Boolean);
  var activeLink = links[0];
  var scheduled = false;
  function setActive(id, reveal) {
    var next = links.find(function (link) { return link.hash === '#' + id; });
    if (!next) return;
    if (next !== activeLink) {
      links.forEach(function (link) {
        if (link === next) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
      activeLink = next;
    }
    if (!reveal || window.matchMedia('(min-width: 1001px)').matches) return;
    var linkRect = next.getBoundingClientRect();
    var listRect = list.getBoundingClientRect();
    if (linkRect.left < listRect.left || linkRect.right > listRect.right) {
      list.scrollLeft += linkRect.left - listRect.left - (listRect.width - linkRect.width) / 2;
    }
  }
  function update() {
    scheduled = false;
    var offset = window.matchMedia('(min-width: 1001px)').matches ? 40 : navigation.getBoundingClientRect().height + 36;
    var current = headings[headings.length - 1];
    for (var index = 0; index < headings.length; index += 1) {
      var heading = headings[index];
      var section = heading.closest('.cebe-cafe-menu__section');
      if (section && section.getBoundingClientRect().bottom > offset) {
        current = heading;
        break;
      }
    }
    if (current) setActive(current.id, !navigation.contains(document.activeElement));
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(update);
  }
  navigation.addEventListener('click', function (event) {
    var link = event.target.closest('a[href^="#menu-"]');
    if (!link) return;
    setActive(link.hash.slice(1), true);
  });
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  window.addEventListener('hashchange', schedule);
  update();
}());

